import icAddSquare from 'assets/images/ic-add-square.svg'
import { Button } from 'avo-ui'
import Table from 'components/commons/table'
import { TABLE_VOTING } from 'configs/award/configTableVoting'
import { ACTION_TYPE } from 'constants/constant'

export const VotingList = ({ dataList, query, onChangeQuery, onActionRow, isLoading }) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-end'}>
                <Button
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Create Voting'}
                    onClick={() => onActionRow({ actionType: ACTION_TYPE.CREATE })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_VOTING.name}
                columns={TABLE_VOTING.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />
        </div>
    )
}
